module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kWxW1"))).then(() => parcelRequire('5erN3'));